// extracted by mini-css-extract-plugin
export default {"container":"Space__container--uHWzg"};